import { Component, OnInit ,ViewEncapsulation} from '@angular/core';
import {Validators, FormControl} from "@angular/forms";
import {AuthService} from "../../core/auth.service";
import {PaymentService} from "../../payment/payment.service";
import { StateService } from 'app/core/state.service';
import {Product, Plan} from "../checkit-dashboard/checkit.model";
import {ActivatedRoute, Router} from "@angular/router";
import {Subject} from "rxjs/Rx";
import {environment} from "../../../environments/environment";
import {Customer, SubscriptionPlan} from "../../payment/models";
import {Observable} from "rxjs/Rx";


@Component({
  selector: 'account',
  templateUrl: 'account.component.html',
  styleUrls: ['account.component.sass'],
    encapsulation: ViewEncapsulation.None
})
export class AccountComponent implements OnInit {

    readonly api = `${environment.functionsURL}/app`;
    public billing_user;
    thing:Array<Product>;
    public cart_prod;
    public next_payment_attempt;
    public selected_product;
    public view_details;
    public current_currency = 'aud';
    private $destroy: Subject<boolean> = new Subject();
    public title_key = {
        manage_subscription:'Manage Subscription',
        manage_payment_method:'Update Payment Method'
    }

    constructor( public auth:AuthService,
                 private pmt:PaymentService,
                 private route: ActivatedRoute,
                 private router: Router,
                 private state:StateService) {
    // auth.signOut();
        route.params.takeUntil(this.$destroy).subscribe(params => {
            if(params.hasOwnProperty('viewDetails')){
                this.view_details = params.viewDetails;
            }
        });
        this.billing_user = Object['assign']({},this.auth.user);
    }
    ngOnInit(){

    }


    updateCart(productObj, cancel?){
        console.log("productObj = " ,productObj)
        if(cancel){
            let cancellation = this.pmt.cancelSubscription(productObj.accountId, productObj.plan);
            console.log('cancellation attempt = ',cancellation);
            cancellation.subscribe(data => {
                console.log('data of cancellation ',data)
            });
            this.cart_prod = null;
            return;
        }
        this.pmt.planId = productObj.plan;
        this.pmt.planQty = productObj.quantity;
        this.cart_prod = productObj;
    }

    viewDetails(detail_name){
        this.router.navigate(['my_account',detail_name]);
    }

    setSource(source){
        console.log('source id ',source.id);
        console.log('this.pmt.planId ',this.pmt.planId);
        console.log('this.pmt.planQty ',this.pmt.planQty);
        this.pmt.attachSubscription(source.id, this.pmt.planId, this.pmt.planQty)
    }

    ngOnDestroy(){
        this.$destroy.next();this.$destroy.complete();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/account/account.component.ts